import React from 'react'
import {connect} from 'react-redux'
import {fromJS} from 'immutable'

import {
  VIEWPORT_TYPES
} from './config/constants'

const {PHONE} = VIEWPORT_TYPES

import CRUDList from './crud_list'
import GroupChatAvatar from './group_chat_avatar'
import GroupChatBookmarkButton from './group_chat_bookmark_button'
import GroupChatSubscribeButton from './group_chat_subscribe_button'

class GroupChatsSubscribed extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      groupChats: fromJS([])
    }

    this.formatGroupChatName = this.formatGroupChatName.bind(this)
    this.onSortChange = this.onSortChange.bind(this)
    this.renderCustomListAction = this.renderCustomListAction.bind(this)
  }

  componentWillMount () {
    this.setSubscribedGroupChats(this.props.subscriptions, this.props.groupChats)
  }

  componentWillReceiveProps (nextProps) {
    const {subscriptions, groupChats} = this.props
    const {subscriptions: nextSubscriptions, groupChats: nextGroupChats} = nextProps

    if (subscriptions !== nextSubscriptions || groupChats !== nextGroupChats) {
      this.setSubscribedGroupChats(nextSubscriptions, nextGroupChats)
    }
  }

  setSubscribedGroupChats (subscriptions, groupChats) {
    groupChats = subscriptions.map((_, key) => groupChats.get(key)).toList()
    groupChats = this.sortGroupChats('name', 'asc', groupChats)

    const isThereSubscription = groupChats.size > 0 ? true : false

    this.setState({groupChats, isThereSubscription})
  }

  sortGroupChats (attr, order, groupChats) {
    const sorter = (g) => (
      typeof(g.get(attr)) === 'string'
      ? g.get(attr).toLowerCase()
      : g.get(attr)
    )

    groupChats = groupChats.sortBy(sorter)

    if (order === 'desc') groupChats = groupChats.reverse()

    return groupChats
  }

  formatGroupChatName (name, group) {
    return (
      <div>
        <div style={{display: 'inline-block', marginRight: 4, fontSize: 14}}>
          <GroupChatAvatar size={30} initials={group.get('initials')}/>
        </div>
        <h5 style={{display: 'inline-block', fontSize: 14}}>{name}</h5>
      </div>
    )
  }

  getAttrs () {
    return [
      {name: 'name', label: 'Group Chat', isSortable: true, isPrimary: true, formatter: this.formatGroupChatName}
    ]
  }

  onSortChange (attr, order) {
    const groupChats = this.sortGroupChats(attr, order, this.state.groupChats)

    this.setState({groupChats})
  }

  renderCustomListAction (group) {
    const width = this.props.viewportType === PHONE ? 'auto' : 250

    return (
      <div className='group-chat-resource-actions' style={{width, textAlign: 'right'}}>
        <GroupChatBookmarkButton groupId={group.get('key')} style={{marginRight: 5}}/>
        <GroupChatSubscribeButton groupId={group.get('key')}/>
      </div>
    )
  }

  render () {
    if (this.state.isThereSubscription === false) {
      return (
        <div style={{textAlign: 'center', margin: '10px auto'}}>
          You don't have any subscribed group chats.
        </div>
      )
    }
    else {
      return (
        <CRUDList
          resources={this.state.groupChats}
          attrs={this.getAttrs()}
          isActionsEnabled={true}
          isActionDetailsEnabled={false}
          customAction={this.renderCustomListAction}
          onSortChange={this.onSortChange}
          paginationStyle={{marginTop: 5, marginBottom: 5}}
          limit={10}/>
      )
    }
  }
}

const mapStateToProps = (state) => {
  const currentUserUid = state.getIn(['currentUser', 'uid'])
  const subscriptions = state.getIn(['groups', '_subscriptions', 'users', currentUserUid])

  return {
    subscriptions,
    groupChats: state.getIn(['groups', 'all'], fromJS({})),
    viewportType: state.getIn(['viewport', 'type'])
  }
}

const GroupChatsSubscribedContainer = connect(
  mapStateToProps
)(GroupChatsSubscribed)

export default GroupChatsSubscribedContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/group_chats_subscribed.js
 **/